import TeamProfileBase from 'components/Generic/TeamProfileBase';
import { TeamMember } from 'model/TeamMember';

type Props = {
  fields: {
    teamMembers: {
      value: Array<TeamMember>;
    };
  };
};

const TeamProfileCardsWithImages = ({ fields, rendering }: Props): JSX.Element => (
  <TeamProfileBase fields={fields} rendering={rendering} showImage />
);

export default TeamProfileCardsWithImages;
